import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useUpdateMessageConfig } from '../../hooks';
import { MessageNavType, MessageConfigData } from '../../interfaces';
import {
    SiteMsgConfig,
    SmsMsgConfig,
    EmailMsgConfig,
    IntegrateMsgConfig,
    WebSocketMsgConfig
} from './components';

interface IMessageSettingConfig {
    type: string; // 头部主菜单类型
    subType: string; // 子菜单类型（没有则为''）
    className?: string;
    configData: MessageConfigData;
}

/**
 * 通知管理配置项
 *
 * @param props IMessageSettingConfig
 * @class
 */
const MessageSettingConfig: React.FC<IMessageSettingConfig> = (props) => {
    const { type, subType, className, configData } = props;

    const { messageConfigData, updateMessageConfig } = useUpdateMessageConfig(configData);

    /**
     * 需要检查短信总数
     */
    const needCheckSmsTotal = useMemo(() => {
        switch (type) {
            case MessageNavType.AppLog:
                return subType !== 'webhook';
            case MessageNavType.TenantCoop:
                return !['corp_coop', 'dept_user'].includes(subType);
            case MessageNavType.OpenPlatform:
                return subType !== 'api';
            case MessageNavType.SystemManagement:
                return !['manage_group', 'manager'].includes(subType);
            default:
                return false;
        }
    }, [type, subType]);

    if (!messageConfigData) {
        return null;
    }

    return (
        <div className={classNames(className, 'fx-message-setting-config')}>
            <div className="message-method">
                <SiteMsgConfig config={messageConfigData?.site} />
                <EmailMsgConfig
                    config={messageConfigData?.email}
                    onUpdateConfig={(config) => {
                        updateMessageConfig(subType, 'email', config);
                    }}
                />
                {type !== MessageNavType.OperationNotify && (
                    <SmsMsgConfig
                        config={messageConfigData?.sms}
                        needCheckSmsTotal={needCheckSmsTotal}
                        onUpdateConfig={(config) => {
                            updateMessageConfig(subType, 'sms', config);
                        }}
                    />
                )}
                {type === MessageNavType.UsageNotify && (
                    <IntegrateMsgConfig
                        config={messageConfigData?.integrate}
                        onUpdateConfig={(config) => {
                            updateMessageConfig(subType, 'integrate', config);
                        }}
                    />
                )}
                {type === MessageNavType.OperationNotify && (
                    <WebSocketMsgConfig
                        config={messageConfigData?.ws}
                        onUpdateConfig={(config) => {
                            updateMessageConfig(subType, 'ws', config);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default MessageSettingConfig;
